<payee-popup [title]="dialogData?.transition_label">
  <ng-template #payeePopupTitleTemplate>
    <h1 class="title">{{ dialogData?.transition_label }}</h1>
  </ng-template>
  @if (loading()) {
    <mat-progress-spinner
      mode="indeterminate"
      diameter="48"
    ></mat-progress-spinner>
  }

  @if (validationErrors) {
    <div class="flex">
      <app-validation-errors [validationErrors]="validationErrors"></app-validation-errors>
      <button
        payee-icon-button
        color="white"
        (click)="validationErrors = undefined"
      >
        <payee-icon name="trash-red"></payee-icon>
      </button>
    </div>
  }

  @if (dialogData && !loading() && !validationErrors) {
    <div class="comparison-container">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Generálás minimum követelényei</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="flex column rules">
          @for (rules of dialogData.rules | keyvalue; track rules.key) {
            <p>{{ rules.key }}: {{ rules.value | json }}</p>
          }
        </div>
      </mat-expansion-panel>
      <!-- Debtor Section -->
      @if (hasData(dialogData.debtor)) {
        <div class="entity-section">
          <h3>Adós: {{ getEntityName(dialogData.debtor) }}</h3>
          <div class="comparison-grid">
            <div class="database-column">
              <h4>Adatbázis adatok</h4>
              @if (dialogData.debtor.database) {
                <div class="data-card">
                  <div
                    class="data-row"
                    [class.mismatch]="isNameMismatch(dialogData.debtor)"
                  >
                    <strong>Név:</strong>
                    {{ dialogData.debtor.database.basicData.name || "Nincs megadva" }}
                  </div>
                  <div
                    class="data-row"
                    [class.mismatch]="isLongNameMismatch(dialogData.debtor)"
                  >
                    <strong>Hosszú név:</strong>
                    {{ dialogData.debtor.database.basicData.long_name || "Nincs megadva" }}
                  </div>
                  <div
                    class="data-row"
                    [class.mismatch]="isTaxNumberMismatch(dialogData.debtor)"
                  >
                    <strong>Adószám:</strong>
                    {{ dialogData.debtor.database.basicData.tax_number || "Nincs megadva" }}
                  </div>
                  <div
                    class="data-row"
                    [class.mismatch]="isTaxNumberRootMismatch(dialogData.debtor)"
                  >
                    <strong>Adószám gyökér:</strong>
                    {{ dialogData.debtor.database.basicData.tax_number_root || "Nincs megadva" }}
                  </div>
                  <div
                    class="data-row"
                    [class.mismatch]="isPartyTypeMismatch(dialogData.debtor)"
                  >
                    <strong>Típus:</strong>
                    {{ dialogData.debtor.database.basicData.partyType?.label || "Nincs megadva" }}
                  </div>
                  <div
                    class="data-row"
                    [class.mismatch]="isStreetMismatch(dialogData.debtor) || isSettlementMismatch(dialogData.debtor)"
                  >
                    <strong>Cím:</strong>
                    {{ dialogData.debtor.database.addressData?.street || "Nincs megadva" }},
                    {{ dialogData.debtor.database.addressData?.settlement || "" }}
                  </div>
                  <div
                    class="data-row"
                    [class.mismatch]="isPostcodeMismatch(dialogData.debtor)"
                  >
                    <strong>Irsz:</strong>
                    {{ dialogData.debtor.database.addressData?.postcode || "Nincs megadva" }}
                  </div>
                  <div
                    class="data-row"
                    [class.mismatch]="isCountryIsoMismatch(dialogData.debtor)"
                  >
                    <strong>Ország:</strong>
                    {{ dialogData.debtor.database.addressData?.country_iso || "Nincs megadva" }}
                  </div>
                  @if (dialogData.debtor.database.contactData) {
                    <div
                      class="data-row"
                      [class.mismatch]="isContactMismatch(dialogData.debtor)"
                    >
                      <strong>Kapcsolat:</strong>
                      {{ dialogData.debtor.database.contactData.type }}:
                      {{ dialogData.debtor.database.contactData.value }}
                    </div>
                  }
                  @if (dialogData.debtor.database.bankAccountData) {
                    <div
                      class="data-row"
                      [class.mismatch]="isBankAccountMismatch(dialogData.debtor)"
                    >
                      <strong>Bankszámla:</strong>
                      {{ dialogData.debtor.database.bankAccountData.account_holder_name || "Nincs megadva" }}
                    </div>
                  }
                  @if (dialogData.debtor.database.bankAccountData) {
                    <div
                      class="data-row"
                      [class.mismatch]="isIbanMismatch(dialogData.debtor)"
                    >
                      <strong>IBAN:</strong>
                      {{ dialogData.debtor.database.bankAccountData.iban || "Nincs megadva" }}
                    </div>
                  }
                  @if (dialogData.debtor.database.bankAccountData) {
                    <div
                      class="data-row"
                      [class.mismatch]="isBbanMismatch(dialogData.debtor)"
                    >
                      <strong>BBAN:</strong>
                      {{ dialogData.debtor.database.bankAccountData.bban || "Nincs megadva" }}
                    </div>
                  }
                </div>
              }
              @if (!dialogData.debtor.database) {
                <div class="no-data">Nincs adatbázis adat</div>
              }
            </div>
            <div class="company-search-column">
              <h4>Cégkeresési adatok</h4>
              @if (dialogData.debtor.company_search) {
                <div class="data-card">
                  <div
                    class="data-row"
                    [class.mismatch]="isNameMismatch(dialogData.debtor)"
                  >
                    <strong>Név:</strong>
                    {{ dialogData.debtor.company_search.basicData.name || "Nincs megadva" }}
                  </div>
                  <div
                    class="data-row"
                    [class.mismatch]="isLongNameMismatch(dialogData.debtor)"
                  >
                    <strong>Hosszú név:</strong>
                    {{ dialogData.debtor.company_search.basicData.long_name || "Nincs megadva" }}
                  </div>
                  <div
                    class="data-row"
                    [class.mismatch]="isTaxNumberMismatch(dialogData.debtor)"
                  >
                    <strong>Adószám:</strong>
                    {{ dialogData.debtor.company_search.basicData.tax_number || "Nincs megadva" }}
                  </div>
                  <div
                    class="data-row"
                    [class.mismatch]="isPartyTypeMismatch(dialogData.debtor)"
                  >
                    <strong>Típus:</strong>
                    {{ dialogData.debtor.company_search.basicData.partyType?.label || "Nincs megadva" }}
                  </div>
                  <div
                    class="data-row"
                    [class.mismatch]="isStreetMismatch(dialogData.debtor) || isSettlementMismatch(dialogData.debtor)"
                  >
                    <strong>Cím:</strong>
                    {{ dialogData.debtor.company_search.addressData?.street || "Nincs megadva" }},
                    {{ dialogData.debtor.company_search.addressData?.settlement || "" }}
                  </div>
                  <div
                    class="data-row"
                    [class.mismatch]="isPostcodeMismatch(dialogData.debtor)"
                  >
                    <strong>Irsz:</strong>
                    {{ dialogData.debtor.company_search.addressData?.postcode || "Nincs megadva" }}
                  </div>
                  <div
                    class="data-row"
                    [class.mismatch]="isCountryIsoMismatch(dialogData.debtor)"
                  >
                    <strong>Ország:</strong>
                    {{ dialogData.debtor.company_search.addressData?.country_iso || "Nincs megadva" }}
                  </div>
                  @if (dialogData.debtor.company_search.contactData) {
                    <div
                      class="data-row"
                      [class.mismatch]="isContactMismatch(dialogData.debtor)"
                    >
                      <strong>Kapcsolat:</strong>
                      {{ dialogData.debtor.company_search.contactData.type }}:
                      {{ dialogData.debtor.company_search.contactData.value || "Nincs megadva" }}
                    </div>
                  }
                  @if (dialogData.debtor.company_search.bankAccountData) {
                    <div
                      class="data-row"
                      [class.mismatch]="isBankAccountMismatch(dialogData.debtor)"
                    >
                      <strong>Bankszámla:</strong>
                      {{ dialogData.debtor.company_search.bankAccountData.account_holder_name || "Nincs megadva" }}
                    </div>
                  }
                  @if (dialogData.debtor.company_search.bankAccountData) {
                    <div
                      class="data-row"
                      [class.mismatch]="isIbanMismatch(dialogData.debtor)"
                    >
                      <strong>IBAN:</strong>
                      {{ dialogData.debtor.company_search.bankAccountData.iban || "Nincs megadva" }}
                    </div>
                  }
                  @if (dialogData.debtor.company_search.bankAccountData) {
                    <div
                      class="data-row"
                      [class.mismatch]="isBbanMismatch(dialogData.debtor)"
                    >
                      <strong>BBAN:</strong>
                      {{ dialogData.debtor.company_search.bankAccountData.bban || "Nincs megadva" }}
                    </div>
                  }
                </div>
              }
              @if (!dialogData.debtor.company_search) {
                <div class="no-data">Nincs cégkeresési adat</div>
              }
            </div>
          </div>
        </div>
      }
      <!-- Client Section -->
      @if (hasData(dialogData.client)) {
        <div class="entity-section">
          <h3>Hitelező: {{ getEntityName(dialogData.client) }}</h3>
          <div class="comparison-grid">
            <div class="database-column">
              <h4>Adatbázis adatok</h4>
              @if (dialogData.client.database) {
                <div class="data-card">
                  <div class="data-row">
                    <strong>Név:</strong>
                    {{ dialogData.client.database.basicData.name || "Nincs megadva" }}
                  </div>
                  <div class="data-row">
                    <strong>Hosszú név:</strong>
                    {{ dialogData.client.database.basicData.long_name || "Nincs megadva" }}
                  </div>
                  <div class="data-row">
                    <strong>Adószám:</strong>
                    {{ dialogData.client.database.basicData.tax_number || "Nincs megadva" }}
                  </div>
                  <div class="data-row">
                    <strong>Adószám gyökér:</strong>
                    {{ dialogData.client.database.basicData.tax_number_root || "Nincs megadva" }}
                  </div>
                  <div class="data-row">
                    <strong>Típus:</strong>
                    {{ dialogData.client.database.basicData.partyType?.label || "Nincs megadva" }}
                  </div>
                  <div class="data-row">
                    <strong>Cím:</strong>
                    {{ dialogData.client.database.addressData?.street || "Nincs megadva" }},
                    {{ dialogData.client.database.addressData?.settlement || "" }}
                  </div>
                  <div class="data-row">
                    <strong>Irsz:</strong>
                    {{ dialogData.client.database.addressData?.postcode || "Nincs megadva" }}
                  </div>
                  @if (dialogData.client.database.contactData) {
                    <div class="data-row">
                      <strong>Kapcsolat:</strong>
                      {{ dialogData.client.database.contactData.type }}:
                      {{ dialogData.client.database.contactData.value }}
                    </div>
                  }
                  @if (dialogData.client.database.bankAccountData) {
                    <div
                      class="data-row"
                      [class.mismatch]="isBankAccountMismatch(dialogData.client)"
                    >
                      <strong>Bankszámla:</strong>
                      {{ dialogData.client.database.bankAccountData.account_holder_name || "Nincs megadva" }}
                    </div>
                  }
                  @if (dialogData.client.database.bankAccountData) {
                    <div
                      class="data-row"
                      [class.mismatch]="isIbanMismatch(dialogData.client)"
                    >
                      <strong>IBAN:</strong>
                      {{ dialogData.client.database.bankAccountData.iban || "Nincs megadva" }}
                    </div>
                  }
                  @if (dialogData.client.database.bankAccountData) {
                    <div
                      class="data-row"
                      [class.mismatch]="isBbanMismatch(dialogData.client)"
                    >
                      <strong>BBAN:</strong>
                      {{ dialogData.client.database.bankAccountData.bban || "Nincs megadva" }}
                    </div>
                  }
                </div>
              }
              @if (!dialogData.client.database) {
                <div class="no-data">Nincs adatbázis adat</div>
              }
            </div>
            <div class="company-search-column">
              <h4>Cégkeresési adatok</h4>
              @if (dialogData.client.company_search) {
                <div class="data-card">
                  <div class="data-row">
                    <strong>Név:</strong>
                    {{ dialogData.client.company_search.basicData.name || "Nincs megadva" }}
                  </div>
                  <div class="data-row">
                    <strong>Hosszú név:</strong>
                    {{ dialogData.client.company_search.basicData.long_name || "Nincs megadva" }}
                  </div>
                  <div class="data-row">
                    <strong>Adószám:</strong>
                    {{ dialogData.client.company_search.basicData.tax_number || "Nincs megadva" }}
                  </div>
                  <div class="data-row">
                    <strong>Típus:</strong>
                    {{ dialogData.client.company_search.basicData.partyType?.label || "Nincs megadva" }}
                  </div>
                  <div class="data-row">
                    <strong>Cím:</strong>
                    {{ dialogData.client.company_search.addressData?.street || "Nincs megadva" }},
                    {{ dialogData.client.company_search.addressData?.settlement || "" }}
                  </div>
                  <div class="data-row">
                    <strong>Irsz:</strong>
                    {{ dialogData.client.company_search.addressData?.postcode || "Nincs megadva" }}
                  </div>
                  @if (dialogData.client.company_search.contactData) {
                    <div class="data-row">
                      <strong>Kapcsolat:</strong>
                      {{ dialogData.client.company_search.contactData.type }}:
                      {{ dialogData.client.company_search.contactData.value || "Nincs megadva" }}
                    </div>
                  }
                  @if (dialogData.client.company_search.bankAccountData) {
                    <div
                      class="data-row"
                      [class.mismatch]="isBankAccountMismatch(dialogData.client)"
                    >
                      <strong>Bankszámla:</strong>
                      {{ dialogData.client.company_search.bankAccountData.account_holder_name || "Nincs megadva" }}
                    </div>
                  }
                  @if (dialogData.client.company_search.bankAccountData) {
                    <div
                      class="data-row"
                      [class.mismatch]="isIbanMismatch(dialogData.client)"
                    >
                      <strong>IBAN:</strong>
                      {{ dialogData.client.company_search.bankAccountData.iban || "Nincs megadva" }}
                    </div>
                  }
                  @if (dialogData.client.company_search.bankAccountData) {
                    <div
                      class="data-row"
                      [class.mismatch]="isBbanMismatch(dialogData.client)"
                    >
                      <strong>BBAN:</strong>
                      {{ dialogData.client.company_search.bankAccountData.bban || "Nincs megadva" }}
                    </div>
                  }
                </div>
              }
              @if (!dialogData.client.company_search) {
                <div class="no-data">Nincs cégkeresési adat</div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      color="alert-green"
      width="wide"
      [disabled]="loading()"
      [loading]="loading()"
      (click)="submit()"
    >
      {{ dialogData?.transition_label || "Generálás" }}
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="alert-red"
      width="wide"
      mat-dialog-close
    >
      Mégse
    </button>
  </ng-template>
</payee-popup>
